import type { ApiResponse } from '~/types/api'

// 获取API基础URL
export function getApiBaseUrl() {
  const config = useRuntimeConfig()
  return config.public.apiBaseUrl
}

// API响应处理器
export function handleApiResponse<T>(response: ApiResponse<T>): T {
  console.log('API Response:', response)
  return response.data
}

// 创建API调用函数
export async function createApiCall<T>(endpoint: string, options: object = {}) {
  const apiBaseUrl = getApiBaseUrl()
  const _fetch = useRequestFetch()

  return _fetch<ApiResponse<T>>(`${apiBaseUrl}${endpoint}`, {
    credentials: 'include',
    ...options,
  })
    .then(handleApiResponse)
}
